<div
  id="device-setting-table-container"
  class="matp-table-container tw-max-h-[calc(100vh_-_250px)]"
>
  <div class="matp-table-actions-area">
    <div class="matp-table-actionst tw-flex"></div>
  </div>

  <div class="matp-table-area">
    <table
      mat-table
      matSort
      matSortActive="date"
      matSortDirection="desc"
      [dataSource]="dataSource"
      id="device-setting-table"
      class="matp-table"
    >
      <!-- 操作種別 -->
      <ng-container matColumnDef="operationType">
        <th mat-header-cell *matHeaderCellDef class="tw-w-52">
          <div mat-sort-header class="matp-table-header-title">操作種別</div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <mat-select
              [(ngModel)]="selectedOperationType"
              name="operationTypeFilter"
              panelClass="matp-table-select-panel"
              (selectionChange)="applyFilter()"
            >
              <mat-option [value]="null"></mat-option>
              @for (operationType of operationTypeList; track $index) {
                <mat-option [value]="operationType">{{
                  operationType
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </th>
        <td
          mat-cell
          name="operationType"
          *matCellDef="let element"
          class="tw-w-52"
        >
          {{ element.operationType }}
        </td>
      </ng-container>

      <!-- 操作ユーザー -->
      <ng-container matColumnDef="userId">
        <th mat-header-cell *matHeaderCellDef class="tw-w-1/5">
          <div mat-sort-header class="matp-table-header-title">
            操作ユーザー
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              name="userId"
              matInput
              appAutocompleteOff
              name="userIdFilter"
              type="text"
              [(ngModel)]="userIdKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="userid-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearUserIdFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="userId" *matCellDef="let element" class="tw-w-1/5">
          {{ element.userId }}
        </td>
      </ng-container>

      <!-- メッセージ -->
      <ng-container matColumnDef="message">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title">メッセージ</div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              name="message"
              matInput
              appAutocompleteOff
              name="messageFilter"
              type="text"
              [(ngModel)]="messageKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="message-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearMessageFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="message" *matCellDef="let element">
          {{ element.message }}
        </td>
      </ng-container>

      <!-- 日時 -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef class="tw-w-1/6">
          <div mat-sort-header class="matp-table-header-title">日時</div>
        </th>
        <td mat-cell name="date" *matCellDef="let element" class="tw-w-1/6">
          {{ element.date | date: " yyyy/MM/dd HH:mm:ss" }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <mat-paginator
    id="devicesetting-table-paginator"
    [length]="dataSource.filteredData.length"
    hidePageSize
    showFirstLastButtons
  >
  </mat-paginator>
</div>
